module.exports = __webpack_public_path__ + "static/media/world.6b9c37fc.png";